import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=ec1815b2&scoped=true"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"
import style0 from "./input-text.vue?vue&type=style&index=0&id=ec1815b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1815b2",
  null
  
)

export default component.exports